import { Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth.js';
import { LoadingState } from '../../components/ui/index.js';
import { ExecutiveCockpit, FinanceHome, ProductOpsHome } from './role-homes-a.js';
import {
  AuditorEvidenceRoom,
  CustomerSuccessPortfolio,
  SecurityPrivacyCockpit,
} from './role-homes-b.js';

/**
 * Role-aware home. Every internal role gets a purpose-built surface built
 * ONLY from endpoints its grants allow — the widgets ask for nothing the
 * API would deny. Roles without a dedicated cockpit land on the surfaces
 * they already own.
 */
export function HomePage() {
  const { me } = useAuth();
  if (!me) return <LoadingState label="Loading…" />;
  const role = me.roles[0];
  const name = me.displayName;

  switch (role) {
    case 'product_owner':
      return <ExecutiveCockpit displayName={name} />;
    case 'product_operations':
      return <ProductOpsHome displayName={name} />;
    case 'finance':
      return <FinanceHome displayName={name} />;
    case 'customer_success':
      return <CustomerSuccessPortfolio displayName={name} />;
    case 'security_privacy_officer':
      return <SecurityPrivacyCockpit displayName={name} />;
    case 'auditor':
      return <AuditorEvidenceRoom displayName={name} />;
    case 'support_engineer':
      return <Navigate to="/support" replace />;
    case 'release_manager':
      return <Navigate to="/releases" replace />;
    default:
      return <Navigate to="/" replace />;
  }
}
